import { Box } from "@chakra-ui/react";
import MyEvaluationAnswer from "./MyEvaluationAnswer";
import MyEvaluationMarkers from "./MyEvaluationMarkers";
import MyEvaluationQuestion from "./MyEvaluationQuestion";
import BlindCorrectionButton from "components/BlindCorrectionButton";

const MyEvaluationParagraphText = () => {
  return (
    <Box width="70%">
      <MyEvaluationQuestion />
      <MyEvaluationAnswer />
      <MyEvaluationMarkers />
      <BlindCorrectionButton />
    </Box>
  );
};

export default MyEvaluationParagraphText;
